import type { GraphMode } from '../../../../src/commonTypes';

export const FLOWY_CONTEXT_MODE_CHANGING_EVENT = 'flowy-context-mode-changing';

export type FlowyContextModeChangingDetail = {
	graphMode: GraphMode;
	isCollaborative: boolean;
};

export type FlowyContextModeStatus = {
	label: string;
	description: string;
};

export const supportsPersonalTeamContext = (graphMode: GraphMode): boolean =>
	graphMode === 'ideate' || graphMode === 'moodboard';

export const getFlowyContextModeStatus = (
	graphMode: GraphMode,
	isCollaborative: boolean
): FlowyContextModeStatus => {
	if (!supportsPersonalTeamContext(graphMode)) {
		return {
			label: 'Inspire · Shared',
			description: 'Inspire board using the shared team workspace',
		};
	}
	return isCollaborative
		? {
				label: 'Team · Shared',
				description: 'Team mode using the shared workspace and team context',
			}
		: {
				label: 'Personal · Private',
				description: 'Personal mode using your private workspace and personal context',
			};
};
